import { render, staticRenderFns } from "./DeprecationBanner.vue?vue&type=template&id=475aeb86&scoped=true"
import script from "./DeprecationBanner.vue?vue&type=script&lang=ts"
export * from "./DeprecationBanner.vue?vue&type=script&lang=ts"
import style0 from "./DeprecationBanner.vue?vue&type=style&index=0&id=475aeb86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475aeb86",
  null
  
)

export default component.exports